/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IAppReportPageOwnProps, IAppReportPageStateProps, IAppReportPageDispatchProps, AppReportPage } from "../../components/appReport/AppReportPage/AppReportPage";
import { ITypedOption } from "../../models/common/typedOption";
import { AppReportThunkDispatch, getAppReportPage } from "source/models/store/appReport";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IAppReportPageOwnProps): IAppReportPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            appReportPage: null,
            list: null,
            //report: null
        };
    }
    const appReport = applicationState.appReport;
    return {
        appState: applicationState.session,
        dataId: appReport.page.dataId,
        appReportPage: appReport.page.appReportPage,
        list: appReport.list,
        //report: appReport.report
    };
}

export function mapDispatchToProps(dispatch: AppReportThunkDispatch): IAppReportPageDispatchProps {
    return {
        onGetAppReportPage: () => dispatch(getAppReportPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IAppReportPageStateProps, IAppReportPageDispatchProps, IAppReportPageOwnProps>(mapStateToProps, mapDispatchToProps)(AppReportPage);